

const state = {
    apple_notify:{},
    time_zone:'',
    submit_url_name:'',
    editInfo:{
        org_id:'',
        campaign_id:'',
        adgroup_id:'',
    },
    create_type:'createOrg',  // createOrg,editOrg,createGroup,editGroup
    is_reload_list: false,
    cur_tab_page:'',
    list_page_query:{
        org_id:[],
        org_name:[],
        campaign_id:[],
        campaign_name:[],
        adgroup_id:[],
        adgroup_name:[],
    },
    common_config:{
        dynamic_day_type:'',
        search_filter_toggle:'',
    },
};

const mutations = {
    ADD_NOTIFY: (state, data) => {
        console.log('add notify',data.id,data.value);
        state.apple_notify[data.id] = data.value;
    },
    REMOVE_NOTIFY: (state, key) => {
        console.log('remove notify',key);
        state.apple_notify[key] = null;
    },
    SET_TIME_ZONE: (state, val) => {
        state.time_zone = val;
    },
    SET_CREATE_TYPE:(state, val) => {
        state.create_type = val;
    },
    SET_EDIT_INFO:(state, data) => {
        state.editInfo.org_id = data.org_id||'';
        state.editInfo.campaign_id = data.campaign_id||'';
        state.editInfo.adgroup_id = data.adgroup_id||'';
    },
    SUBMIT_URL_NAME:(state, val) => {
        state.submit_url_name = val;
    },
    IS_RELOAD_LIST:(state) => {
        state.is_reload_list = !state.is_reload_list;
    },
    SET_CUR_TAB_PAGE:(state,val) => {
        state.cur_tab_page = val;
    },
    SET_LIST_PAGE_QUERY:(state,data) => {
        state.list_page_query.org_id = data.org_id||[];
        state.list_page_query.org_name = data.org_name||[];
        state.list_page_query.campaign_id = data.campaign_id||[];
        state.list_page_query.campaign_name = data.campaign_name||[];
        state.list_page_query.adgroup_id = data.adgroup_id||[];
        state.list_page_query.adgroup_name = data.adgroup_name||[];
    },
    RESET_LIST_PAGE_QUERY:(state) => {
        state.list_page_query.org_id = [];
        state.list_page_query.org_name = [];
        state.list_page_query.campaign_id = [];
        state.list_page_query.campaign_name = [];
        state.list_page_query.adgroup_id = [];
        state.list_page_query.adgroup_name = [];
    },
    SET_COMMON_CONFIG:(state,val) => {
        state.common_config = {...val};
    },
    CLEAR_ORG_LIST_PAGE_QUERY:(state)=>{
        state.list_page_query.org_id = [];
        state.list_page_query.org_name = [];
    },
    CLEAR_CAMPAIGN_LIST_PAGE_QUERY:(state)=>{
        state.list_page_query.campaign_id = [];
        state.list_page_query.campaign_name = [];
    },
    CLEAR_ADGROUP_LIST_PAGE_QUERY:(state)=>{
        state.list_page_query.adgroup_id = [];
        state.list_page_query.adgroup_name = [];
    },
};


export default {
    namespaced: true,
    state,
    mutations,
}
